export default __webpack_public_path__ + "static/media/Add_Registration_Code.747788ec.png";